import { render, staticRenderFns } from "./add.vue?vue&type=template&id=11149006"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11149006')) {
      api.createRecord('11149006', component.options)
    } else {
      api.reload('11149006', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=11149006", function () {
      api.rerender('11149006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/return/inform/add.vue"
export default component.exports